import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './list.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions"
import { Contract } from "model/contract/contractList.model";

export interface ContractDetailsProps extends DetailsStateAndDispatchProps<Contract,'templateType' | 'templateProcess'>,
  RouteComponentProps, StateProps, DispatchProps {
}
const ContractDetails: FC<ContractDetailsProps> = (props) => {
  return (
    <DetailsPage<Contract,'templateType' | 'templateProcess'>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Contract>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ contract }: RootState) => ({
  entity: contract.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ContractDetails);
